import { CreateMetadata } from "@/features/socratic/hooks/use-create-dialogue";
import { SocraticDialogueFragment } from "@/generated/graphql";

type Props = {
  latestDialogue?: SocraticDialogueFragment | null;
  maxAttempts: number;
  createMetadata?: CreateMetadata | null;
};

/**
 * Helper for displaying the number of attempts remaining
 *
 * Use to prevent flash of future content between creating a dialogue and navigating to it
 */
export function attemptsRemaining({
  latestDialogue,
  maxAttempts,
  createMetadata,
}: Props): number {
  if (!latestDialogue) return maxAttempts;

  // While creating & after creation, we use the attempt number we had before
  // (we can't just use latestDialogue from the query, because the query cache
  // gets updated before the mutation resolves, so there would be a flash of
  // incorrect content)
  if (createMetadata) {
    if (createMetadata.attemptNumber.prev === null) {
      return numAttempsRemaining(0, maxAttempts);
    } else {
      return numAttempsRemaining(
        createMetadata.attemptNumber.prev,
        maxAttempts
      );
    }
  }

  // Before creation, the logic is simple
  return numAttempsRemaining(latestDialogue.attemptNumber, maxAttempts);
}

const numAttempsRemaining = (used: number, max: number) =>
  Math.max(max - used, 0);
